import { Injectable } from "@angular/core";
import { RestService } from "../../core/core/rest.service";

@Injectable()
export class HolidayCalendarRest {
  constructor(private http: RestService) { }

  public delete(id: number) {
    return this.http.get<boolean>(`api/holidaycalendar/delete/${id}`);
  }
  public deleteMany(holidayCalendarIds: number[]) {
    return this.http.post(`api/holidaycalendar/delete/many`, holidayCalendarIds);
  }

  public save(date: any, descrption: string) {
    return this.http.post(`api/holidaycalendar/save`, { dateStr: date, description: descrption });
  }

  public addDefaultsDatesForYear(year: number) {
    return this.http.get<boolean>(`api/holidaycalendar/adddefaults/${year}`);
  }
}